import "./bookingLoaders.css";

/** Animated pen writing on a sheet. Shown while shipment documents generate. */
function BookShipmentGeneratingDocumentsLoading() {
  return <span className="generating-documents-loader" />;
}

export default BookShipmentGeneratingDocumentsLoading;
